import { ComponentPropsWithRef } from "react";
import classes from "./Input.module.css";

const Input = ({
  classes: variant,
  error,
  className,
  ...rest
}: ComponentPropsWithRef<"input"> & {
  classes?: string;
  error?: boolean;
}) => {
  const inputClasses = `${variant ? classes[variant] : ""} ${
    error ? classes.error : ""
  } ${className ?? ""}`;

  return <input className={inputClasses} {...rest} />;
};

export default Input;
